import { useEffect, useState ,useContext} from "react";
import { baseURL } from "../constants";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LanguageContext } from "../LanguageContext"; // Import the context

const ContactUsHook = () => {
  // State for each input field
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const { language } = useContext(LanguageContext); // Use the context
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Handle form submission

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await axios.post(`${baseURL}/contact-us`, {
        name,
        phone,
        email,
        message,
      });

      toast.success(
        language === "en"
          ? "Thank you for contacting us!"
          : "شكرًا لتواصلك معنا!"
      );
      setName("");
      setPhone("");
      setEmail("");
      setMessage("");
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    language,
    error,
    handleSubmit,
    name,
    setName,
    phone,
    setPhone,
    email,
    setEmail,
    message,
    setMessage,
  };
};

export default ContactUsHook;
